// extracted by mini-css-extract-plugin
export default {"container":"yY-z","list":"zY-z"};